module.exports = __webpack_public_path__ + "static/img/abb-pc.5ce40dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abb-pc.png
// module id = e17o
// module chunks = 17